import { HOSTS } from 'core'

// Env
const IS_SERVER = typeof window === 'undefined'
const PSL_ENV = IS_SERVER ? process.env.PSL_ENV : window.ENV.PSL_ENV

// URLs
export const MAIN_HOST =
  PSL_ENV === 'local'
    ? HOSTS.psl.local
    : PSL_ENV === 'live'
      ? HOSTS.psl.live
      : HOSTS.psl.staging

// Sessions
export const SESSION_EXPIRATION_TIME = 1000 * 60 * 60 * 24 * 30
export const CODE_QUERY_PARAM = 'code'
export const TARGET_QUERY_PARAM = 'target'
export const TYPE_QUERY_PARAM = 'type'
export const REDIRECT_TO_QUERY_PARAM = 'redirectTo'
export const NEW_EMAIL_ADDRESS_SESSION_KEY = 'new-email-address'
export const VERIFICATION_TYPES = [
  'onboarding',
  'reset-password',
  'change-email',
] as const

// Stripe
export const GRACE_PERIOD = 1000 * 60 * 60 * 23
export const PRICE_LOOKUP_KEYS = [
  'free',
  'hobby_monthly',
  'hobby_yearly',
  'pro_monthly',
  'pro_yearly',
] as const

// UI
export const DEFAULT_LIMIT = 10
export const SPRITE = '/sprite-8.svg'
export const TREEMAP_HEIGHT = 700
export const IMG_DIMS = {
  desktop: { w: 500, h: 348 },
  mobile: { w: 250, h: 498 },
} as const
export const QUEUED_CODE = -1
export const ACTIVE_CODE = -2
export const ERROR_CODE = -3
export const PENDING = [ACTIVE_CODE, QUEUED_CODE]
export const SETTINGS_WIDTH = 218
